import { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

/** Position for an item placed between two neighbours (either may be missing). */
export function positionBetween(before?: string | null, after?: string | null): string {
  const a = before ?? null;
  const b = after ?? null;
  // Guard against corrupt or equal keys so a bad row never blocks a drag.
  if (a !== null && b !== null && a >= b) return generateKeyBetween(a, null);
  return generateKeyBetween(a, b);
}

export function positionAfter(last?: string | null): string {
  return generateKeyBetween(last ?? null, null);
}

export function positionBefore(first?: string | null): string {
  return generateKeyBetween(null, first ?? null);
}

export function positionsBetween(before: string | null, after: string | null, count: number): string[] {
  if (before !== null && after !== null && before >= after) return generateNKeysBetween(before, null, count);
  return generateNKeysBetween(before, after, count);
}

/** Plain string comparison: fractional keys are designed to sort with it (not localeCompare). */
export function comparePosition(a: { position: string }, b: { position: string }): number {
  return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
}

/**
 * Position for moving an item to `index` within `siblings` (sorted, and not containing the moved item).
 */
export function positionAtIndex(siblings: { position: string }[], index: number): string {
  const clamped = Math.max(0, Math.min(index, siblings.length));
  return positionBetween(siblings[clamped - 1]?.position, siblings[clamped]?.position);
}
